export default {
  id: "",
  organizationId: "",
  type: "",
  status: "",
  card: {
    firstName: null,
    lastName: null,
    brand: "",
    expiryMonth: 1,
    expiryYear: 2025,
    number: null,
    securityCode: null,
    maskedNumber: "****************",
    address: {
      line1: "",
      line2: "",
      city: "",
      state: "",
      postalCode: "",
      country: ""
    }
  }
};
